import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

const ProtectedRoute = ({ children, role }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-blue"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // "any" role: any authenticated user can access
  if (role === 'any') {
    return children;
  }

  // Comptable role - redirect to comptable portal if trying to access admin pages
  if (role === 'admin' && user.role === 'comptable') {
    return <Navigate to="/comptable" replace />;
  }

  // Admin routes: hyperadmin, super_admin and store_admin
  if (role === 'admin' && user.role !== 'super_admin' && user.role !== 'store_admin' && user.role !== 'hyperadmin') {
    return <Navigate to="/employee/scan" replace />;
  }

  // Hyperadmin routes: only hyperadmin
  if (role === 'hyperadmin' && user.role !== 'hyperadmin') {
    return <Navigate to="/admin/dashboard" replace />;
  }

  // Comptable routes: only comptable, super_admin and hyperadmin
  if (role === 'comptable' && user.role !== 'comptable' && user.role !== 'super_admin' && user.role !== 'hyperadmin') {
    return <Navigate to="/admin/login" replace />;
  }

  // Employee routes: redirect admins to dashboard
  if (role === 'employee' && (user.role === 'super_admin' || user.role === 'store_admin' || user.role === 'hyperadmin')) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
